import { HandwritingContentType } from '@shared/enums/quest-type';
import { TopicType  } from '@shared/enums/topic-type';
import { Quest } from '../quest';

export class HandwritingQuest extends Quest {
  detailKey = 'digitalResourcesHandwritingActivityQuestDetail';
  topicKey: string;
  topicType: TopicType;
  name?: string;
  score?: string;
  activityId?: string;
  customText: string;
  contentType: HandwritingContentType;
  updatedOn: Date | string;

  constructor(data?: {[key: string]: any}) {
    super(data);
    if (data) {
      this.setAllowedProperties(data, this.detailKey);
    }
  }

  // props should map to quest detail
  getAllowedPropertyNames(): string[] {
    return [
      'activityId',
      'name',
      'topicKey',
      'topicType',
      'customText',
      'contentType',
    ];
  }

  label(): string {
    return this.description ? this.description : `${this.topicType} - ${this.name}`;
  }

  typeLabel(): string {
    return 'Handwriting Activity';
  }
}
